import script from "./Customerallocations.vue?vue&type=script&lang=ts&setup=true"
export * from "./Customerallocations.vue?vue&type=script&lang=ts&setup=true"

import "./Customerallocations.vue?vue&type=style&index=0&id=037fbe72&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-037fbe72"]])

export default __exports__